// extracted by mini-css-extract-plugin
var _1 = "LGO7V";
var _2 = "CMcyS";
export { _1 as "toolsImage", _2 as "toolsSectionHeight" }
